// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"113":"25d0181a839d2f3eda99","293":"86da4ce458b78fb23fa8"}[chunkId] + ".js";
};